module.exports = __webpack_public_path__ + "static/media/MSC.cf0c4d49.svg";